import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQueryClient, useMutation } from 'react-query';

function useLessonIssueStatus() {
  const { privateFetch } = useContext(FetchContext);
  const queryClient = useQueryClient();

  const updateStatus = ({ issueId, status }) =>
    privateFetch.patch(`/v1/admin/lesson-issues/${issueId}/status`, { status });

  return useMutation(updateStatus, {
    onSettled() {
      queryClient.invalidateQueries('lesson-issues');
    },
  });
}

export default useLessonIssueStatus;
